import {get, post} from '@/utils/http'


/**
 * 查询礼物
 * @param deviceId {String}
 * @param scene {string}
 * @param giftName {string}
 * @param pageNo {number}
 * @param dataType {'taqu'|'yolo'}
 * @param minVal {number}
 * @returns {Promise<ResultDTO<GiftMessage>>}
 */
async function queryGift({deviceId,scene,giftName,pageNo,dataType,minVal}) {
    return await get('/data/gift/query',{deviceId,scene,giftName,pageNo,dataType,minVal})
}


async function queryGameDataBase({dataType}) {
    return await get('/data/game-data/base',{dataType})
}

/**
 * 查询统计
 * @param deviceId {String}
 * @param scene {string}
 * @param giftName {string}
 * @param pageNo {number}
 * @param dataType {'taqu'|'yolo'}
 * @returns {Promise<ResultDTO<PageContainer<RawMessage>>>}
 */
async function queryHistory({deviceId,scene,pageNo,dataType}){
    return await get("/data/history/query", {deviceId,scene,pageNo,dataType});
}

async function querySiteData(deviceId){
    return await get("/data/site/summary", {deviceId});
}

/**
 *
 * @returns {Promise<ResultDTO<Array<DataCollectClient>>>}
 */
async function queryCollectClients(){
    return await get("/data/collect/clients");
}

/**
 * 获取用户信息
 * @param platfrom {string}
 * @param data {string}
 * @returns {Promise<ResultDTO<string>}
 */
async function doDataDecode({platform, data}) {
    return await post('/debug/data/decode', {platform, data}, "application/x-www-form-urlencoded")
}

/**
 * 获取用户信息
 * @param platfrom {string}
 * @param data {string}
 * @returns {Promise<ResultDTO<Array<PlatformItem>>>}
 */
async function getPlatforms() {
    return await get('/config/platform/list')
}

async function doSaveRobotConfig(robotConfig) {
    return await post('/config/robot/save', robotConfig)
}

async function getRobotConfig({deviceId, dataType}) {
    return await get('/config/robot/get', {dataType})
}

export default {
    queryGift,queryHistory,querySiteData,queryCollectClients,getPlatforms,doDataDecode,queryGameDataBase, getRobotConfig,doSaveRobotConfig
}
